export const translations = {
  ru: {
    SIGNING_BUTTON_TEXT: "Подписать",
    SMS_CODE_INPUT_LABEL: "СМС-код",
    SMS_CODE_RESEND_LABEL_TEXT: "Отправить код повторно",
    REQUEST_CODE_LABEL_TEXT:
      "Запросить смс-код повторно можно через {{value}} секунд",
    REQUEST_CODE_FIRST_LABEL_ERROR_TEXT:
      "Неверный смс-код. Осталось {{value}} секунд",
    REQUEST_CODE_SECOND_LABEL_ERROR_TEXT:
      "Исправьте его или отправьте повторно",
    ERROR_LABEL_TEXT:
      "Превышен лимит попыток, пожалуйста, запросите код повторно",
    REVOKING_SIGNATURE_BUTTON_TITLES: {
      ALL_SIGNATURES: "Снять все подписи",
      OWN_SIGNATURE: "Снять подпись",
    },
    SIGNING_TYPE_BUTTON_TITLES: {
      SIGN: "Подписать",
      VISE: "Завизировать",
    },
  },
  en: {
    SIGNING_BUTTON_TEXT: "Sign",
    SMS_CODE_INPUT_LABEL: "SMS code",
    SMS_CODE_RESEND_LABEL_TEXT: "Resend code",
    REQUEST_CODE_LABEL_TEXT:
      "You can request the SMS code again after {{value}} seconds",
    REQUEST_CODE_FIRST_LABEL_ERROR_TEXT:
      "Invalid SMS code. {{value}} seconds left",
    REQUEST_CODE_SECOND_LABEL_ERROR_TEXT: "Correct it or resend it",
    ERROR_LABEL_TEXT:
      "The attempt limit has been exceeded, please request the code again",
    REVOKING_SIGNATURE_BUTTON_TITLES: {
      ALL_SIGNATURES: "Remove all signatures",
      OWN_SIGNATURE: "Remove signature",
    },
    SIGNING_TYPE_BUTTON_TITLES: {
      SIGN: "Sign",
      VISE: "Vise",
    },
  },
};
